import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const QuestionsIcon = ({
  width = 48,
  color = 'foraBlue',
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
      <g fill={getSemanticTextColor(color)} fillRule="evenodd">
        <path
          d="M59.401 46.559c1.836-3.239 2.972-6.928 2.972-10.92 0-9.297-5.703-17.245-13.798-20.582.865 2.624 1.341 5.413 1.341 8.322 0 14.733-11.94 26.677-26.668 26.686 4.085 4.767 10.073 7.85 16.85 7.85 4 0 7.702-1.14 10.95-2.99l11.325 2.968L59.4 46.559z"
          transform="translate(8.79 10.5)"
        />
        <path
          d="M24.508 22.434l.036.9c0 1.252-1.016 2.272-2.268 2.272-1.251 0-2.272-1.02-2.272-2.272v-.815c0-1.97 1.199-3.72 2.98-4.357.838-.299 1.4-1.096 1.404-1.978.005-.535-.232-1.079-.641-1.484-.41-.41-.91-.628-1.484-.641-1.158.004-2.103.953-2.103 2.111 0 1.252-1.011 2.268-2.263 2.268-1.256 0-2.272-1.016-2.272-2.268 0-3.648 2.967-6.633 6.611-6.651 1.769-.058 3.462.708 4.718 1.969 1.261 1.26 1.983 2.98 1.97 4.718-.014 2.789-1.787 5.293-4.416 6.228m-2.232 10.54c-1.274 0-2.307-1.033-2.307-2.302 0-1.279 1.033-2.308 2.307-2.308 1.275 0 2.304 1.029 2.304 2.308 0 1.27-1.03 2.303-2.304 2.303m0-32.977C9.971-.002.001 9.973.001 22.274c0 3.991 1.131 7.68 2.967 10.92L.001 44.526l11.32-2.967c3.248 1.849 6.95 2.99 10.955 2.99 12.3 0 22.276-9.971 22.276-22.276 0-12.3-9.975-22.276-22.276-22.276"
          transform="translate(8.79 10.5)"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
